import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RingoverService } from '../../services/ringover.service';
import { RingoverContact } from '../../models/ringover-contact.model';
import { RingoverWidgetComponent } from '../ringover-widget/ringover-widget.component';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'app-ringover-contacts',
  standalone: true,
  imports: [CommonModule, RingoverWidgetComponent, TableModule, ButtonModule, CardModule, ToastModule, InputTextModule],
  providers: [MessageService],
  templateUrl: './ringover-contacts.component.html',
  styleUrls: ['./ringover-contacts.component.css']
})
export class RingoverContactsComponent implements OnInit {
  contacts: RingoverContact[] = [];
  isLoading: boolean = false;
  isSyncing: boolean = false;

  constructor(
    private ringoverService: RingoverService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.loadContacts();
  }

  loadContacts(): void {
    this.isLoading = true;
    this.ringoverService.getContacts().subscribe({
      next: (data) => {
        this.contacts = data;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Erreur lors du chargement des contacts', err);
        this.messageService.add({severity: 'error', summary: 'Erreur', detail: 'Impossible de charger les contacts.'});
        this.isLoading = false;
      }
    });
  }

  syncContacts(): void {
    this.isSyncing = true;
    this.ringoverService.syncContacts().subscribe({
      next: (res) => {
        this.messageService.add({severity: 'success', summary: 'Succès', detail: res.message});
        this.loadContacts();
        this.isSyncing = false;
      },
      error: (err) => {
        console.error('Erreur lors de la synchronisation', err);
        this.messageService.add({severity: 'error', summary: 'Erreur', detail: 'La synchronisation a échoué.'});
        this.isSyncing = false;
      }
    });
  }
}
